
// import { getMessaging, onMessage } from 'firebase/messaging'
import headerComponent from '~/components/headerComponent.vue'
export default {
  components: {
    headerComponent
  },
  data () {
    return {
      display: true
    }
  },
  computed: {
    hasPermission () {
      return this.$store.getters['authProfile/hasPermission']
    }
  },
  // async fetch ({ store }) {
  //   if (!store.getters['authProfile/isLoggedIn']) { return }
  //   await store.dispatch('notifications/fetch', {
  //     per_page: 6,
  //     page: 1,
  //     orderBy: 'created_at'
  //   })
  // },
  beforeCreate () {
    this.$vuetify.rtl = true
  },
  async created () {
    if (!this.$store.getters['authProfile/isLoggedIn'] || !this.hasPermission('indexNotification')) { return }
    console.log('fetching notifications...')
    await this.$store.dispatch('notifications/fetch', {
      per_page: 6,
      page: 1,
      orderBy: 'created_at'
    })
  },
  methods: {
    showNotes () {
    //
    }
  }
}
